import React, { useMemo } from "react";
import { EditableTable } from "../../../components/EditableTable";

const monthNames = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

const RateReferenceTable = ({ rateReferences, vendors, isLoading, onEdit }) => {
  const vendorLookup = useMemo(() => {
    const map = {};
    (vendors || []).forEach((vendor) => {
      if (vendor?.id) {
        map[vendor.id] = vendor;
      }
    });
    return map;
  }, [vendors]);

  const rows = useMemo(() => {
    const items = (rateReferences || []).map((row) => {
      const vendor = vendorLookup[row.vendorId];
      return {
        ...row,
        vendorDisplay: vendor?.name || `Vendor #${row.vendorId}`,
        monthDisplay: monthNames[row.effectiveMonth] || row.effectiveMonth,
        kwhTierDisplay:
          row.kwhTier === null || row.kwhTier === undefined || row.kwhTier === ""
            ? "Default"
            : row.kwhTier,
      };
    });

    return {
      items,
      toUpdate: [],
      toDelete: [],
    };
  }, [rateReferences, vendorLookup]);

  const fieldTitles = [
    "Vendor",
    "Month",
    "Year",
    "kWh Tier",
    "Generation",
    "Distribution",
    "Transmission",
    "Discount",
    "",
  ];

  const fieldTypes = [
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "labelSmall",
    "editBtn",
  ];

  const fieldNames = [
    "vendorDisplay",
    "monthDisplay",
    "effectiveYear",
    "kwhTierDisplay",
    "generationRatePerKwh",
    "distributionRatePerKwh",
    "transmissionRatePerKwh",
    "discountRatePerKwh",
    "",
  ];

  return (
    <EditableTable
      readOnly={true}
      canSave={false}
      canDelete={false}
      canAddItems={false}
      isLoading={isLoading}
      defaultItemCount={10}
      tableTitle="Rate Reference Schedules"
      objectArray={rows}
      fieldTitles={fieldTitles}
      fieldTypes={fieldTypes}
      fieldNames={fieldNames}
      canExport={true}
      showItemNumber={true}
      handlePreviewClickParentMethod={onEdit}
    />
  );
};

export default RateReferenceTable;
